import { GetFormByIdEndPoint, GetAllFormsEndPoint, EditFormEndPoint } from "common/constants";
import { makeRequest } from "../helpers/makeRequest";
import { makeAuthenticatedRequest } from "helpers/authenticatedRequest";

export const getFormByID = async ({ form_key, pageNumber, formData, readonly = false, startingPage = -1, dataReadOnly = false, hideSubmitButton = null }, signal = null) => {
	var endpoint = "";
	var bodyData = JSON.stringify(formData);
	var hideSubmitButtonStr = hideSubmitButton !== null && hideSubmitButton !== undefined && hideSubmitButton !== "" ? "&hideSubmitButton=" + hideSubmitButton : "";

	if ((pageNumber === null || pageNumber === undefined) && readonly === false) {
		endpoint = `${GetFormByIdEndPoint}${form_key}?dataReadOnly=${dataReadOnly}${hideSubmitButtonStr}`;
		bodyData = {};
	} else if (readonly === false && (pageNumber !== null || pageNumber !== undefined) && (startingPage === null || startingPage === undefined || startingPage === -1)) {
		endpoint = `${GetFormByIdEndPoint}${form_key}?pageNumber=${pageNumber}&dataReadOnly=${dataReadOnly}${hideSubmitButtonStr}`;
	} else if (readonly === false && (pageNumber !== null || pageNumber !== undefined) && (startingPage !== null || startingPage !== undefined || startingPage !== -1)) {
		endpoint = `${GetFormByIdEndPoint}${form_key}?pageNumber=${pageNumber}&initialPage=${startingPage}&dataReadOnly=${dataReadOnly}${hideSubmitButtonStr}`;
	} else if (readonly === true && (pageNumber === null || pageNumber === undefined)) {
		endpoint = `${GetFormByIdEndPoint}${form_key}?readonly=${readonly}&dataReadOnly=${dataReadOnly}${hideSubmitButtonStr}`;
	} else {
		if (startingPage != -1) {
			endpoint = `${GetFormByIdEndPoint}${form_key}?pageNumber=${pageNumber}&readonly=${readonly}&dataReadOnly=${dataReadOnly}&initialPage=${startingPage}${hideSubmitButtonStr}`;
		} else {
			endpoint = `${GetFormByIdEndPoint}${form_key}?pageNumber=${pageNumber}&readonly=${readonly}&dataReadOnly=${dataReadOnly}${hideSubmitButtonStr}`;
		}
	}

	try {
		const data = await makeRequest(endpoint, {
			method: "POST",
			body: bodyData,
			signal,
		});

		const formJson = JSON.parse(data.data.formData);

		return formJson;
	} catch (e) {
		console.log("error", e);
	}
};

export const getAllFroms = async (params = {}, signal = null) => {
	try {
		const { pageNumber, recordsPerPage } = params;
		const url = `${GetAllFormsEndPoint}?pageNumber=${pageNumber}&recordsPerPage=${recordsPerPage}`;
		return await makeAuthenticatedRequest(url, { method: "GET", signal });
	} catch (err) {
		console.error("API ERROR:", err);
		throw err;
	}
};

export const saveFrom = async ({ form_key, data }, signal = null) => {
	try {
		const url = EditFormEndPoint + form_key;

		return await makeAuthenticatedRequest(url, {
			method: "PUT",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(data),
			signal,
		});
	} catch (err) {
		console.error("API ERROR:", err);
		throw err;
	}
};
